import React from 'react'

import { KeyboardArrowDown, KeyboardArrowRight } from '@mui/icons-material'
import { Divider as DividerBase, Grid as BaseGrid, styled } from '@mui/material'

import { TreeItem as TreeItemBase, SimpleTreeView as TreeViewBase } from '@mui/x-tree-view'

export const Root = styled('div')`
  width: 100%;
`

export const AddProduct = styled('div')`
  color: ${props => props.theme.palette.green[50]};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 12px;
  letter-spacing: 0;
  line-height: 21px;
`

export const ButtonWrapper = styled('section')`
  width: 100%;
  margin-left: 10px;
`

export const Column = styled(({ flexGrow, margin, padding, width, textAlign, ...props }) => (
  <BaseGrid item {...props} />
))`
  flex-grow: ${props => props.flexGrow ?? ''};
  margin: ${props => props.margin || '0'};
  padding: ${props => props.padding || '0 5px'};
  width: ${props => props.width};
  text-align: ${props => props.textAlign};
`

export const Divider = styled(({ margin, ...props }) => <DividerBase {...props} />)`
  &.MuiDivider-root {
    margin: ${props => props.margin};
  }
`

export const LineJump = styled('br')``

export const Link = styled('a')`
  color: ${props => props.theme.palette.gray[50]};
  cursor: pointer;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  height: 20px;
  letter-spacing: 0;
  line-height: 20px;
  width: 57px;

  &::before {
    content: '<';
    margin-right: 15px;
  }
`

export const LinkAddProduct = styled('a')`
  color: ${props => props.theme.palette.blue[50]};
  cursor: pointer;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 12px;
  letter-spacing: 0;
  line-height: 23px;
`

export const Row = styled(({ alignItems = false, background = false, border = false, margin, ...props }) => (
  <BaseGrid container {...props} />
))`
  margin: ${props => props.margin || '0 -5px'};
  width: 100%;
  background-color: ${props => props.background && props.theme.palette.green[95]};
  border: ${props => props.border && '1px solid'};
  border-color: ${props => props.border && props.theme.palette.green[75]};
  padding: ${props => props.padding && '2px'};
  align-items: ${props => props.alignItems && 'center'};
`

export const Strong = styled('span')`
  font-weight: bold;
`

export const ArrowDownIcon = styled(({ size, ...props }) => <KeyboardArrowDown {...props} />)`
  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.gray[50]};
    font-size: ${props => {
      if (props.size === 'large') {
        return '26px'
      }

      if (props.size === 'small') {
        return '20px'
      }

      return '24px'
    }};
  }
`

export const ArrowRightIcon = styled(({ size, ...props }) => <KeyboardArrowRight {...props} />)`
  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.gray[50]};
    font-size: ${props => {
      if (props.size === 'large') {
        return '26px'
      }

      if (props.size === 'small') {
        return '20px'
      }

      return '24px'
    }};
  }
`

export const TreeView = styled(TreeViewBase)``

export const TreeItem = styled(({ ...props }) => <TreeItemBase {...props} />)``
